import { Injectable } from '@angular/core';
import { SSE } from 'sse.js';
import { MatTableDataSource } from '@angular/material/table';
import { Observable } from 'rxjs';
import { RestProcedureService } from 'src/app/service/rest/procedure/rest-procedure.service';
import { Procedure, ProcedureCloneBody, ProcedureContentCloneBody, Step, StepOrder } from './procedure.model';
import { ServerSentService } from 'src/app/service/utils/server-sent/server-sent.service';

@Injectable()
export class ProcedureService {

  private _procedure: Procedure;
  private _dataSourceSteps: MatTableDataSource<Step> = new MatTableDataSource<Step>();

  constructor(private procedureRest: RestProcedureService,private sseService: ServerSentService) { }

  get procedure() : Procedure {
    return this._procedure;
  }

  set procedure(procedure : Procedure) {
    this._procedure = procedure;
    if(procedure) this.dataSourceSteps = new MatTableDataSource(procedure.steps);
  }

  get procedureSteps() : Step[] {
    if(this.procedure)  return this.procedure.steps;
    else return [];
  }

  set procedureSteps(steps : Step[]) {
    if(this.procedure) this.procedure.steps = steps;
  }

  public get dataSourceSteps(): MatTableDataSource<Step> {
    return this._dataSourceSteps;
  }
  public set dataSourceSteps(value: MatTableDataSource<Step>) {
    this._dataSourceSteps = value;
  }

  updateProcedure() : Observable<Procedure> {
    return this.procedureRest.updateProcedure(this.procedure);
  }

  addProcedure() : Observable<Procedure>{
    return this.procedureRest.createProcedure(this.procedure);
  }

  cloneProcedure(clonedProcedure : Procedure): Observable<Procedure>{
    return this.procedureRest.createProcedure(clonedProcedure);
  }

  deleteProcedure() : Observable<boolean>{
    return this.procedureRest.deleteProcedure(this.procedure.id);
  }

  orderSteps(order: StepOrder[]) {
    this.procedureRest.orderSteps(order).subscribe(result => { }, error => { console.log(error) });
  }

  importProcedureCSVFile(importFile: File) {
    const formData = new FormData();
    formData.append('file',importFile, importFile.name);
   return this.procedureRest.uploadProcedureCSV(formData);
  }

  exportProcedureCSVFile(): Observable<any> {
    return this.procedureRest.downloadProcedureCSV();
  }

  // returns an observable of the sse call
  private getServerSentEvent(url: string, importFile: FormData): Observable<SSE> {
    return new Observable((observer) => {
      const eventSource = this.sseService.getEventSourceWithPost(url, importFile);
      // on answer from message listener
      eventSource.onmessage = (event) => {
        observer.next(JSON.parse(event.data));
      };
      eventSource.onerror = (error) => {
        observer.error(error);
      };
      eventSource.stream();
    });
  }

  cloneSelectedProcedure(procedureData : ProcedureCloneBody,languageId:string): Observable<any>{
    return this.procedureRest.cloneProcedure(procedureData,languageId);
  }

  cloneSelectedProcedureContents(cloneData : ProcedureContentCloneBody, languageId:string): Observable<any>{
    return this.procedureRest.cloneProcedureContents(cloneData, languageId);
  }

}
